import {  BATCHPART_LIST } from './../constant/ActionTypes';

export const batchPartReducer = (state, action) => {
    switch (action.type) {
        case BATCHPART_LIST:
            return { 
                ...state, 
                batchPartList: action.payload 
            };
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./contexts/reducer/batchPartReducer.js